import { createSelector } from "@reduxjs/toolkit";
export const campaign = state => state.campaignReducer.campaign;
